module.exports = __webpack_public_path__ + "img/wqzk1.8df7fa96.png";